import { isPlainObject } from 'lodash';
import { ensureArray, safeJSONParse } from '@/utils';

const LEAD_CREATED_RECORDS_KEY = 'OPC/__LEAD_CREATED_RECORDS__';
function getLeadCreatedRecords() {
  const val = safeJSONParse(window.sessionStorage.getItem(LEAD_CREATED_RECORDS_KEY));
  return isPlainObject(val) ? val : {};
}
function setLeadCreatedRecords(val) {
  window.sessionStorage.setItem(LEAD_CREATED_RECORDS_KEY, JSON.stringify(val));
}

const state = {
  leadCreationSupportedPlans: [],
  leadCreatedRecords: getLeadCreatedRecords(),
};

/** @typedef {typeof state} IState */

/** @type {import('vuex').GetterTree<IState>} */
const getters = {
  leadCreationSupportedPlans: (state) => state.leadCreationSupportedPlans,
  leadCreatedRecords: (state) => state.leadCreatedRecords,
};

/** @type {import('vuex').MutationTree<IState>} */
const mutations = {
  setLeadCreationSupportedPlans(state, data) {
    state.leadCreationSupportedPlans = ensureArray(data);
  },
  setLeadCreatedRecord(state, { key, data }) {
    state.leadCreatedRecords = { ...state.leadCreatedRecords, [key]: data };
    setLeadCreatedRecords(state.leadCreatedRecords);
  },
};

export default {
  state,
  getters,
  mutations,
};
